var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _vm.footer
        ? _c(
            "v-footer",
            { attrs: { fixed: true, padless: true, height: "90" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "text-center",
                  attrs: {
                    flat: "",
                    tile: "",
                    width: "100%",
                    dark: "",
                    color: "grey darken-3"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    {
                      staticClass:
                        "d-flex justify-space-between pb-0 mt-3 py-0",
                      attrs: { dir: "ltr" }
                    },
                    [
                      _vm._l(_vm.items, function(item) {
                        return _c(
                          "div",
                          { key: item.text, staticClass: "pt-1" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "white mx-3",
                                attrs: { icon: "", link: "", to: item.to }
                              },
                              [
                                _c("v-icon", { class: item.css }, [
                                  _vm._v(_vm._s(item.icon))
                                ])
                              ],
                              1
                            ),
                            _c("p", { staticClass: "pt-1" }, [
                              _vm._v(_vm._s(_vm.$t(item.text)))
                            ])
                          ],
                          1
                        )
                      }),
                      _c("div", { staticClass: "py-0" }, [
                        _c("div", { staticClass: "mx-8" })
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.footer
        ? _c(
            "v-row",
            { attrs: { "no-gutters": "", justify: "end" } },
            _vm._l(_vm.items, function(item) {
              return _c(
                "v-col",
                { key: item.text, attrs: { cols: "4" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-2 text-none body-2 font-weight-medium",
                      attrs: {
                        depressed: "",
                        small: _vm.$vuetify.breakpoint.sm,
                        color: _vm.btncoloring,
                        width: _vm.getBtnWidth,
                        link: "",
                        to: item.to
                      }
                    },
                    [
                      _c("v-icon", { class: item.css, attrs: { left: "" } }, [
                        _vm._v(_vm._s(item.icon))
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t(item.text)) + " ")
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }